// session
// initSession
import { ENTRY_POINT } from '@/types/entryPoints';

// initChat
export interface PreChatDetailItem {
  label: string;
  value: string;
  transcriptFields: unknown[];
  displayToAgent: boolean;
}

export interface EntityFieldsMapsItem {
  isExactMatch: boolean;
  label: string;
  doFind: false;
  fieldName: string;
  doCreate: boolean;
}

export interface PreChatEntitiesItem {
  saveToTranscript: string;
  linkToEntityName: null;
  showOnCreate: boolean;
  linkToEntityField: null;
  entityName: string;
  entityFieldsMaps: EntityFieldsMapsItem[];
}

// chat

declare const FromType: 'native' | 'h5';

export enum ReasonType {
  agent = 'agent',
  client = 'client',
  timeout = 'chatbot_session_close_timeout',
}

export interface GetMessageParams {
  from: typeof FromType;
}

// 请求建立
export interface ChatRequestSuccessData {
  type: string;
  message: {
    connectionTimeout: number;
    estimatedWaitTime: number;
    sensitiveDataRules: unknown[];
    transcriptSaveEnabled: boolean;
    url: string;
    queuePosition: number; // 排队位置
    customDetails: unknown[];
    visitorId: string;
    geoLocation: {
      organization: string;
      city: string;
      countryName: string;
      latitude: number;
      countryCode: string;
      longitude: number;
    };
    postChatUrl: string;
  };
}

// 排队信息变化
export interface QueueUpdateData {
  type: string;
  message: {
    estimatedWaitTime: number;
    position: number; // 排队位置
  };
}

// 客服接入
export interface ChatEstablishedData {
  type: string;
  message: {
    name: string;
    userId: string;
    items: unknown[];
    sneakPeekEnabled: boolean;
    chasitorIdleTimeout: {
      isEnabled: boolean;
      warningTime: number;
      timeout: number;
    };
  };
}

// 聊天消息
export interface ChatMessage {
  type: string;
  message: {
    text: string; // 消息
    name: string;
    schedule: {
      responseDelayMilliseconds: number;
    };
    agentId: string;
    message_id: number;
  };
}

// 聊天结束
export interface ChatEnd {
  type: string;
  message: {
    attachedRecords: unknown[];
    reason: typeof ReasonType;
  };
}

// 会话出现异常, 可以直接退出流程。
export interface ChatRequestFail {
  type: string;
  message: {
    reason: typeof ReasonType;
    attachedRecords: unknown[];
    postChatUrl: string;
  };
}

// 代表agent掉线了，会话不能继续维护，可以直接退出流程
export interface AgentDisconnect {
  type: string;
  message: {};
}

// 代表agent正在输入信息
export interface AgentTyping {
  type: string;
  message: {
    name: string;
    agentId: string;
  };
}

// 代表agent停止了信息输入
export interface AgentNotTyping {
  type: string;
  message: {
    name: string;
    agentId: string;
  };
}

export declare type MessageItem =
  | ChatRequestSuccessData
  | QueueUpdateData
  | ChatEstablishedData
  | ChatMessage
  | ChatEnd
  | ChatRequestFail
  | AgentDisconnect
  | AgentTyping
  | AgentNotTyping;

export interface ChatResData {
  messages: MessageItem[];
  sequence: number;
  offset: number;
}

// postMessage
export interface PostMessageParams {
  text: string;
  type?: 'file' | 'TEXT' | 'FILE' | 'IMG' | 'VID' | 'ORDER';
  params?: {
    text?: string;
    url?: string; // 高清原始图片, 文件 url 地址
    thumbnail?: string; // 图片的缩略图
    name?: string;
    filename?: string;
    size?: number; // 500KB
    order_select?: object;
  };
}

export interface BaseRes<T = any> {
  code: number;
  msg: string;
  data: T;
}

// img
export interface PostImgParams {
  file: string;
}

export interface Categories {
  user_type: number;
  user_type_content: string;
  enquiry_types: {
    id: 1;
    region: 'SG';
    enquiry_type: 'Payments \u0026 Escrow';
  }[];

  category_name: string;
  displayed_options: {
    queue_name: string;
    option_name: string;
  }[];
}

export type createMultipartUploadRes = BaseRes<{
  upload_id: string;
  file_key: string;
}>;

export type uploadPartRes = BaseRes<{
  part_num: string;
  etag: string;
}>;

export type validateDownloadRes = BaseRes<{
  exist: boolean;
  filename: string;
}>;

export type ReportUserReadMsgParams = {
  latest_agent_chat_message_id: string;
};

export type ChatEndParams = {
  is_missed_by_queue_button?: boolean;
  missed_by_button_reason?: string;
};

export enum QueueType {
  inhouse = 1,
  saleforce,
}

export type QueryQueueAvailabilityParams = {
  channel: number;
  queue_type: QueueType;
  entry_point_id: ENTRY_POINT;
  user_type_id: number;
  reason_code_id: number;
};


export interface ICheckIsCounldInBoundParams {
  entry_point: ENTRY_POINT;
  enquiry_type: number;
  user_type: number;
  reason_code?: number;
}

export interface SubmitWebformParams {
  form_sn: string;
  data: any;
  channel: 'CHATBOT_ID';
}
